import { makeStyles } from "makeStyles";
import { StoragePermissionRole } from "../models";
import { Box, Table, TableBody, TableCell, TableRow } from "@mui/material";
import { permissionsTableStyles } from "../styles";
import SingleValues from "../SingleValues";

const useStyles = makeStyles()((theme) => ({
  ...permissionsTableStyles(theme)
}));

interface Props {
  rights?: StoragePermissionRole[];
}

const FilesRights: React.FunctionComponent<Props> = (props) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.childTableContainer}>
      <Table size="small" className={classes.borderedTable}>
        <TableBody>
          {props.rights?.map((right) => (
            <TableRow key={right.roleName}>
              <TableCell>{right.roleName}</TableCell>
              <TableCell>
                <SingleValues values={right.principalDisplayNames} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default FilesRights;
